class WebSocketService {
    constructor() {
      this.socket = null;
      this.listeners = [];
      this.isConnected = false;
      this.reconnectTimer = null;
    }
  
    connect() {
      const token = localStorage.getItem("access_token");
      if (!token) return;
  
      const config = window.pcaSettings;
      if (!config || !config.websocket || !config.websocket.uri) {
        console.error("Configuración WebSocket no disponible");
        return;
      }
      const endpoint = config.websocket.uri;
      this.socket = new WebSocket(`${endpoint}?token=${encodeURIComponent(token)}`);
  
      this.socket.onopen = () => {
        console.log("Conexión WebSocket establecida");
        this.isConnected = true;
        this.clearReconnectTimer();
      };
  
      this.socket.onclose = () => {
        console.log("Conexión WebSocket cerrada");
        this.isConnected = false;
        this.setupReconnect();
      };
  
      this.socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          this.notifyListeners(data);
        } catch (error) {
          console.error("Error al procesar mensaje:", error);
        }
      };
    }
  
    addListener(callback) {
      this.listeners.push(callback);
      return () => this.removeListener(callback);
    }
  
    removeListener(callback) {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    }
  
    notifyListeners(data) {
      this.listeners.forEach(callback => callback(data));
    }
  
    setupReconnect() {
      this.clearReconnectTimer();
      this.reconnectTimer = setTimeout(() => {
        console.log("Intentando reconectar...");
        this.connect();
      }, 5000);
    }
  
    clearReconnectTimer() {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    }
  }
  
  export default new WebSocketService();
  